// extracted by mini-css-extract-plugin
export var editor = "_16-0";
export var flowSidebar = "_4k-2";